import { createContext, useContext } from 'react';

export const BatchDetailsContext = createContext<() => void>(() => {
  throw new Error('useBatchDetails must be used within a BatchDetailsProvider');
});

export const useBatchDetails = () => useContext(BatchDetailsContext);
